module.exports = __webpack_public_path__ + "images/emoji/mobile_phone_off.9d4eb70a359a081d8ef2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/mobile_phone_off.png
// module id = tP9i
// module chunks = 24